import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState
} from './workflow-restrictions.action';
import { WorkflowRestrictions } from './workflow-restrictions.model';

export interface WorkflowRestrictionsRecordsState {
    listData: WorkflowRestrictions[];
    singleData: WorkflowRestrictions;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: WorkflowRestrictionsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const WorkflowRestrictionsRecordReducer = createReducer(

    initialState,

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);